import api from '../services/api';

const verifyToken = (
  token: string,
  setIsValidToken: (isValidToken: boolean) => void,
  setIsLoading?: (isLoading: boolean) => void,
  setUserEmail?: (userEmail: string) => void,
) => {
  api.post(`auth/verify/${token}`, { token })
    .then((response) => {
      const { isTokenValid, userEmail } = response.data;
      setIsValidToken(isTokenValid);
      if (setUserEmail) {
        setUserEmail(userEmail);
      }
    }).finally(() => {
      if (setIsLoading) setIsLoading(false);
    });
};

export default verifyToken;
